import React, { useState, useEffect, useRef } from 'react';

export class ContextMenuAction {
    text: string;
    action: () => void;
}

interface IContextMenuProps {
    caption?: string;
    isVisible?: boolean;
    style?: React.CSSProperties;
    actions: ContextMenuAction[];
}

const ContextMenu: React.FC<IContextMenuProps> = (props) => {
    const mount = document.getElementById('context-menu-portal');

    const [isOpen, setIsOpen] = useState(false);
    const [closeTimeout, setCloseTimeout] = useState(null);
    const menuRef = useRef(null);
    const parentRef = useRef(null);

    // handle window scroll
    //

    useEffect(() => {
        if (menuRef && menuRef.current && mount) {
            const rect = menuRef.current.getBoundingClientRect();

            if (isOpen) {
                mount.appendChild(menuRef.current);
                mount.style.position = 'absolute';
                mount.style.top = rect.top + 11 + window.scrollY + 'px';
                mount.style.left = rect.left + 7 + window.scrollX + 'px';
                mount.style.width = rect.width + 'px';
                mount.style.height = rect.height + 'px';
                mount.style.zIndex = '100000';
            } else {
                parentRef.current.appendChild(menuRef.current);
                mount.style.top = '-2000px';
            }
        }
    }, [isOpen]);

    const clickContextMenu = (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        setIsOpen(true);
    };

    const leaveContextMenu = () => {
        if (!closeTimeout) {
            setCloseTimeout(setTimeout(() => setIsOpen(false), 400));
        }
    };

    const enterContextMenu = () => {
        if (closeTimeout) {
            clearTimeout(closeTimeout);
            setCloseTimeout(null);
        }
    };

    const fireAction = (event: React.MouseEvent, action: ContextMenuAction) => {
        event.preventDefault();
        event.stopPropagation();
        setIsOpen(false);
        setTimeout(action.action, 0);
    };

    if (props.actions) {
        return (
            <div ref={parentRef} className={`context-menu ${props.isVisible ? 'showing' : ''}`}>
                <span className="context-menu-button" onClick={clickContextMenu} />
                <div className="context-menu-placement" />
                <div
                    ref={menuRef}
                    className={`context-menu-items ${isOpen ? 'showing' : ''}`}
                    onMouseLeave={leaveContextMenu}
                    onMouseEnter={enterContextMenu}
                >
                    <div className="items-header">Options</div>
                    {props.actions.map((action: ContextMenuAction, index: number) => (
                        <div className="item" key={`action-${index}`} onClick={(e) => fireAction(e, action)}>
                            {action.text}
                        </div>
                    ))}
                </div>
            </div>
        );
    } else {
        return null;
    }
};

export default ContextMenu;



// WEBPACK FOOTER //
// ./src/components/common/ContextMenu.tsx